import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      about: 'Fast & secure non-password authorization',
      selfieLogin: 'Log in by Selfie',
      accessCamera: 'Provide access to your camera',
      or: 'or',
      scan: 'Scan QR code by Enface ID app',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      allowAccess: 'Allow access to the camera',
      cancelButton: 'Cancel',
      permissionDenied: 'We can’t go on your permission',
      permissionInfo: 'Our App needs an access to your camera only to use it for your security and privacy.  The face scan will not be given to third parties',
      frameFace: 'Put your face in the frame',
      errorFrame: 'Put your face in the frame',
      errorBack: 'Move back',
      errorCloser: 'Move closer',
      errorFaceMissing: 'Frame your face in the frame',
      outOfTime: "Oops! Looks like you've run out of time",
      tryAgain: 'Try again',
      passcode: 'Enter passcode',
      repeatPasscode: 'Repeat passcode',
      exit: 'Exit',
      loading: 'Check Enface ID application to continue...',
      granted: 'Access granted',
      grantedUse: 'Use this Enface ID next time',
      grantedPin: 'Use pin-code for fast log in',
      grantedButton: 'Go to website',
      denied: 'Access denied',
      deniedText: 'You can not use Enface ID for security reasons',
      deniedButton: 'Retry',
      success: 'Good',
      pinMatch: "Passcodes don't match",
      pinFail: 'Login failed with passcode',
      modalTitle: 'Too many attempts',
      modalText: 'Reload the page and try again',
      errorConnectionTitle: 'No Connection',
      errorConnectionText: 'Your internet connection was interrupted, Please retry.',
      errorNotFoundTitle: 'Page Not Found',
      errorNotFoundText: 'The page you are looking for doesn’t seem to exist…',
      errorErrorTitle: 'Error!',
      errorErrorText: 'Enface server is not responding. Please try again later',
      errorParametersTitle: 'Parameters error',
      errorNoBackendURLText: 'Please provide "backendURL" variable',
      errorNoProjectIdText: 'Please provide "projectId" variable',
      errorBadBackendURLText: 'Bad "backendURL" variable. Please, read the integration rules',
      errorFailedText: 'Enface authorization failed',
      declinedErrorTitle: 'Declined!',
      declinedText: 'User has declined this authorization request',
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
